import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ArticlePreview",
    component: () => (__SERVER__ ? require("./article-preview-view") : import("./article-preview-view"))
});

export default definition;
